import React from "react";

export default function LoadFailed () {

  return (
    <center style={{width:'100%'}}>
        <p style={{ fontFamily: 'comicbold', fontSize: 'x-large' }}>Contents not available.</p>
        <p style={{ fontFamily: 'comicbold', fontSize: 'large',color:'gray'}}>
            Reasons:
            <br></br>
            · Network error
            <br></br>
            · Database error
            <br></br>
            Please wait and try again. If problem not solved, please email to us. Many thanks.
        </p>
    </center>
  );
}
